<template>
  <div class="row">
    <div class="col-12">
      <m-input
        class="search-form-field"
        v-model="search.SENDINGTYPENAME"
        nolabel
        :placeholder="$t('search.sendingtypename')"
      ></m-input>
    </div>
  </div>
</template>

<script>
import api from "../../api";
export default {
  data() {
    return {
      search: {
        SENDINGTYPENAME: null,
      },
    };
  },

  methods: {
    getSearch() {
      return this.search;
    },
    clearSearch() {
      this.search = {
        SENDINGTYPENAME: null,
      };
    },
  },
};
</script>

<style></style>
